module.exports = __webpack_public_path__ + "static/media/formImage.736d73a7.svg";